<template>

  <vs-row id="distribution-list-list">
    <vs-col>
      <vs-row>
        <vs-col>
          <card-page card-title="Distribution Lists">
            <div class="vx-row m-0">
              <grid-panel
                  id="distribution-list"
                  :auto-group-column-def="{headerName: 'Market'}"
                  height="md-plus"
                  :auto-size="true"
                  :column-defs="columnDefs"
                  :gridOptions="gridOptions"
                  :autoGroupColumnDef="autoGroupColumnDef"
                  :url="() => this.$api.facilities.distributionLists.list(id)"
                  class="vx-col w-1/3 p-0 m-0"
                  @rowClicked="loadDistributionList"
                  :show-search="false"
              />
              <grid-panel
                  v-if="underwriterId > 0"
                  height="md-plus"
                  ref="distributionListGrid"
                  auto-size
                  :column-defs="distributionListColDefs"
                  :url="url"
                  class="vx-col w-2/3 underwriter-list"
                  @rowClicked="view"
              >
                <vs-dropdown-item v-if="componentAccess.canCreate.access">
                  <span
                      class="flex items-center"
                      @click="$router.push({
                      name: 'facilities.distribution-lists.create',
                       params: {FDO_PK: underwriterId}
                      })"
                  >
                    <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-4 w-4"/>
                    <span>Create Distribution List</span>
                  </span>
                </vs-dropdown-item>
              </grid-panel>
              <grid-panel
                  v-else
                  height="md-plus"
                  ref="distributionListGrid"
                  :data="[]"
                  auto-size
                  :column-defs="distributionListColDefs"
                  class="vx-col w-2/3 underwriter-list"
                  @rowClicked="view"
              >
                <vs-dropdown-item v-if="componentAccess.canCreate.access" disabled>
                  <span
                      class="flex items-center"
                      @click="$router.push({
                      name: 'facilities.distribution-lists.create',
                       params: {FDO_PK: underwriterId}
                      })"
                  >
                    <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-4 w-4"/>
                    <span>Create Distribution List</span>
                  </span>
                </vs-dropdown-item>
              </grid-panel>
            </div>
          </card-page>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import CardPage from '../../../components/Views/CardPage';

export default {
  name: 'DistributionListList',
  components: {
    GridPanel,
    CardPage,
  },
  mixins: [CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canCreate: {
          route: 'facilities.distribution-lists.create',
          access: false,
        },
      },
      gridOptions: {
        groupRowRendererParams: {
          suppressCount: true
        }
      },
      autoGroupColumnDef: {
        headerName: 'Market',
        cellRendererParams: {
          suppressCount: true,
        }
      },
      columnDefs: [
        {
          headerName: 'Market #',
          field: 'MarketDescription',
          width: 225,
          filter: 'agTextColumnFilter',
          rowGroup: true,
          hide: true,
        },
        {
          headerName: 'FDO',
          field: 'FDO_PK',
          width: 175,
          filter: 'agTextColumnFilter',
          rowGroup: true,
          hide: true,
          valueFormatter: ({value}) => {
            return `FDO #${value}`;
          },
        },
        {
          headerName: 'Underwriter',
          field: 'CompanyName',
          filter: 'agTextColumnFilter',
          width: 350,
        },
      ],
      underwriterId: null,
      url: null,
      distributionListColDefs: [
        {
          headerName: 'Report',
          filter: 'agTextColumnFilter',
          field: 'Type',
          width: 350,
        },
        {
          headerName: 'Number of Recipients',
          filter: 'agTextColumnFilter',
          field: 'Recipients_Count',
          width: 350,
        },
      ]
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    async view({data}) {
      const route = 'facilities.distribution-lists.view';

      if (await this.canAccessRoute(route)) {
        this.$router.push({name: route, params: {id: this.id, distributionListId: data.id}}).catch(() => {});
      }
    },
    loadDistributionList(data) {
      if (data.node.uiLevel !== 1) {
        return;
      }
      
      const dataLocal = data.node.allLeafChildren[0].data;
      
      if (typeof dataLocal === 'undefined' || !dataLocal.FDO_PK) {
        return;
      }

      const refresh = this.url !== null;

      this.underwriterId = dataLocal.FDO_PK;
      this.url = () => this.$api.facilities.underwriters.relationship('distribution-lists', this.underwriterId);

      if (refresh) {
        this.$refs.distributionListGrid.list();
      }
    }
  },
};
</script>

<style lang="scss">
  #distribution-list-list {
    #distribution-list {
      border-right: 1px solid #D5DAE0;
      padding: .9rem .9rem 1.3rem;

      > div:first-of-type {
        display: none;
      }

      .ag-header {
        display: none;
      }

      .ag-body-horizontal-scroll {
        display: none;
      }

      .ag-group-contracted,
      .ag-group-expanded {
        margin-right: 7.5px;
      }
      .ag-row,
      .ag-row-odd {
        margin: 4px 0;
        padding: 0 0.6rem;
        font-size: 15px !important;
        background-color: white !important;
        border: none !important;

        &.ag-row-group-expanded {
          background-color: #F8F8F8 !important;
        }

        .ag-row-group-indent-0 {
          padding-left: 0px;
        }

        .ag-row-group-indent-1 {
          padding-left: 23px;
        }
      }

      .ag-cell-focus {
        border: none !important;
        font-weight: bold;
      }

      .ag-row-level-2 {
        margin-left: 64px !important;
      }

      .ag-center-cols-clipper {
        overflow-x: visible;

        .ag-center-cols-viewport {
          overflow: visible;

          .ag-center-cols-container {
            width: 100% !important;
          }
        }
      }

      .ag-side-bar {
        display: none;
      }
    }

    .title-row {
      border-bottom: 1px solid #D5DAE0;
      padding: 1.2rem 1.9rem;
    }

    .underwriter-list {
      position: relative;
      top: -54px;
      padding: 0;

      .action-bar-wrapper {
        .top-row {
          border: none !important;
        }

        > .bottom-row {
          border: none !important;
        }
      }
    }
}
</style>
